import type { AuthRepository } from '@contexts/auth/domain';
import type { UseCase } from '@contexts/shared/application';
import { uuidValueObject } from '@contexts/shared/domain';

export type Delete2FAMethodInput = {
	methodId: string;
};

export type Delete2FAMethodUseCase = UseCase<Delete2FAMethodInput, string>;

export function delete2FAMethodBuilder(authRepository: AuthRepository): Delete2FAMethodUseCase {
	return async function delete2FAMethod(input: Delete2FAMethodInput): Promise<string> {
		const methodId = uuidValueObject().validate('methodId', input.methodId);

		return authRepository.delete2FAMethod(methodId);
	};
}
